import * as RTK from '@reduxjs/toolkit';
import { CatalogueEntry } from '../data/catalogueEntry';

export type State = Array<CatalogueEntry>;

const initialState: State = [];

export enum CatalogueError {
    CATALOGUE_NOT_INITIALISED = 'CATALOGUE_NOT_INITIALISED',
    RANGE_NOT_INITIALISED = 'RANGE_NOT_INITIALISED',
    PRODUCTS_NOT_INITIALISED = 'PRODUCTS_NOT_INITIALISED',
    CONFIGURABLE_PROPERTIES_NOT_INITIALISED = 'CONFIGURABLE_PROPERTIES_NOT_INITIALISED',
}

export const slice = RTK.createSlice({
    name: 'catalogue',
    initialState,
    reducers: {
        setCatalogue(_state, action: RTK.PayloadAction<Array<CatalogueEntry>>) {
            return action.payload;
        },
    },
});

export const { setCatalogue } = slice.actions;

export const reducer = slice.reducer;
